import React, { type FunctionComponent } from 'react'
import styled from '@emotion/styled'
import { colors, SVGIcon } from 'ic-snacks'
import { FormattedMessage } from 'react-intl'
import { NAV_ITEM_HEIGHT } from 'legacy/common/theme'
import { NavLinkText, NavLinkSubText } from './NavTypography'
import { type SubNavItemProps } from 'legacy/components/Nav/SubNavItem'
import { type OnClick } from 'utils/react/event.types'
import { type LocalNavTheme } from 'legacy/components/Nav/nav.types'

const SubNavLinkInner = styled.span<{ isActive?: boolean; theme?: LocalNavTheme }>`
  display: flex;
  align-items: center;
  height: ${NAV_ITEM_HEIGHT};
  cursor: pointer;
  background-color: ${({ isActive, theme }) =>
    isActive ? (theme.inverted ? colors.GRAY_46 : colors.GRAY_88) : 'inherit'};
  &:hover {
    background-color: ${({ theme }) => (theme.inverted ? colors.GRAY_46 : colors.GRAY_88)};
  }
  transition: background-color 0.2s;
`

const StatusIcon = styled(SVGIcon)`
  margin: 16px;
  min-height: 20px;
  min-width: 20px;
`

export const SubnavDescription = styled.div`
  text-decoration: none;
  overflow: hidden;
  height: ${NAV_ITEM_HEIGHT};
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding-left: 20px;
  &:visited {
    text-decoration: none;
  }
`

interface SubNavItemContentProps extends Pick<SubNavItemProps, 'iconName' | 'details' | 'label'> {
  onClick?: OnClick
  isActive: boolean
  id?: string
}

export const SubNavItemContent: FunctionComponent<SubNavItemContentProps> = ({
  onClick,
  isActive,
  label,
  children,
  details,
  iconName,
  id,
}) => (
  <SubNavLinkInner isActive={isActive} onClick={onClick}>
    <SubnavDescription id={id}>
      <NavLinkText title={label}>
        {children || (label && <FormattedMessage id={label} />)}
      </NavLinkText>
      {details && <NavLinkSubText>{details}</NavLinkSubText>}
    </SubnavDescription>
    {iconName && <StatusIcon name={iconName} color={colors.GRAY_46} size="small" />}
  </SubNavLinkInner>
)
